module.exports = __webpack_public_path__ + "static/img/067_TO8_1632.6ea1c78.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/067_TO8_1632.jpg
// module id = AiZY
// module chunks = 0